import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"
import { useLocation } from "@reach/router"
export const SEO = ({
    title,
    description,
    keywords,
    image,
    OGUrl,

    canonical,
    pathname,
    children
}) => {
    const {
        title: defaultTitle,
        description: defaultDescription,
        keywords: defaultKeywords,
        favicon,
        siteUrl,
        seoGlobalSettings: { robotsMeta, openGraphImage }
    } = useSiteMetadata()

    const location = useLocation()

    const defaultUrl = `${siteUrl}${pathname || location.pathname}`
    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        keywords: keywords || defaultKeywords,
        image: image || openGraphImage?.sourceUrl,

        url: defaultUrl,
        canonicalUrl: defaultUrl
    }

    return (
        <>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="keywords" content={seo.keywords} />
            <meta name="image" content={seo.image} />
            <meta name="og:image" content={seo.image} />
            <meta name="og:url" content={seo.url} />
            <meta name="og:type" content="website" />
            <meta name="og:title" content={seo.title} />
            <meta name="og:description" content={seo.description} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:url" content={seo.url} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />
            <meta name="icon" content={favicon} />
            <link rel="canonical" href={seo.canonicalUrl} />
            {robotsMeta &&
                robotsMeta.map(item => {
                    if (item.includes("noindex")) {
                        return <meta name="robots" content="noindex" />
                    }
                    if (item.includes("nofollow")) {
                        return <meta name="robots" content="nofollow" />
                    }
                })}
            <link rel="icon" href={favicon} />

            {children}
        </>
    )
}
